import {
    SUCCESSFUL_GET_SALEORDERS_SIGNEDCONTRACT,
    SUCCESSFUL_GET_SALEORDERS_PAYABLE,
    SUCCESSFUL_GET_SALEORDERS_WITH_PAYMENTS,
    SUCCESSFUL_GET_STATUS_SALEORDER_IN_PROGRESS
} from "./actionConst";

const initialState = {
    items: [],
    item: {},
    saleOrderInProgressStatus: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SUCCESSFUL_GET_SALEORDERS_SIGNEDCONTRACT:
            return {
                ...state,
                items: action.payload
            }

        case SUCCESSFUL_GET_SALEORDERS_PAYABLE:
            return {
                ...state,
                items: action.payload
            }

        case SUCCESSFUL_GET_SALEORDERS_WITH_PAYMENTS:
            return {
                ...state,
                items: action.payload
            }

        case SUCCESSFUL_GET_STATUS_SALEORDER_IN_PROGRESS:
            return {
                ...state,
                saleOrderInProgressStatus: Object.assign({}, action.payload)
            }
        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/saleorders/saleordersReducer.js